// Servicos.js - Gestão de Serviços (SEM STOCK) - COM PREFIXO SR
// 🔥 IVA CORRIGIDO: SUPORTA 0%, NUNCA USA FALLBACK 16 E USA A ESTRUTURA IMPOSTOS
// 🔥 PRECO DE VENDA CALCULADO COM IVA EM TEMPO REAL (como no Produtos.js)
// 🔥 CONFIG EMPRESA CORRIGIDA: fetchConfigEmpresa recebe o user e faz merge completo

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Servicos.css';
import { Icon } from './SharedComponents';

const API_BASE_URL = '/api';

// ==============================================
// CONFIGURAÇÕES PADRÃO (fallback)
// ==============================================
const CONFIG_PADRAO = {
    moeda: {
        simbolo: 'MT',
        codigo: 'MZN',
        casasDecimais: 2,
        separadorDecimal: ',',
        separadorMilhar: '.'
    },
    formatoData: 'DD/MM/YYYY',
    timezone: 'Africa/Maputo',
    idioma: 'pt-PT',
    iva: null
};

// ==============================================
// CONSTANTES
// ==============================================
const TIPOS_PRECO = [
    { value: 'Fixo', label: 'Preço Fixo' },
    { value: 'Hora', label: 'Por Hora' },
    { value: 'Mes', label: 'Por Mês' },
    { value: 'Projeto', label: 'Por Projeto' }
];

// ==============================================
// COMPONENTE DE GRÁFICO
// ==============================================
const SimpleBarChart = ({ data, labels, colors, title, formatValue }) => {
    const maxValue = Math.max(...data, 1);

    return (
        <div className="simple-chart">
            {title && <h4 className="chart-title">{title}</h4>}
            <div className="chart-bars">
                {data.map((value, index) => {
                    const percentage = (value / maxValue) * 100;
                    const color = colors?.[index] || '#4f46e5';
                    const displayValue = formatValue ? formatValue(value) : value;
                    return (
                        <div key={index} className="chart-bar-wrapper">
                            <div className="chart-bar-label">{labels[index]}</div>
                            <div className="chart-bar-track">
                                <div
                                    className="chart-bar-fill"
                                    style={{
                                        width: `${Math.max(percentage, 5)}%`,
                                        backgroundColor: color
                                    }}
                                >
                                    <span className="chart-bar-value">{displayValue}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default function Servicos() {
    // ==============================================
    // ESTADOS PRINCIPAIS
    // ==============================================
    const [servicos, setServicos] = useState([]);
    const [filteredServicos, setFilteredServicos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [configEmpresa, setConfigEmpresa] = useState(CONFIG_PADRAO);

    // ==============================================
    // MODAIS
    // ==============================================
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [servicoToDelete, setServicoToDelete] = useState(null);
    const [servicoDetalhes, setServicoDetalhes] = useState(null);
    const [message, setMessage] = useState({ text: '', type: '' });

    // ==============================================
    // TABS DOS MODAIS
    // ==============================================
    const [activeTab, setActiveTab] = useState('geral');
    const [editActiveTab, setEditActiveTab] = useState('geral');
    const [detailsActiveTab, setDetailsActiveTab] = useState('dados');

    // ==============================================
    // PAGINAÇÃO
    // ==============================================
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
    });

    // ==============================================
    // ESTADOS DE USUÁRIO E EMPRESA
    // ==============================================
    const [isSuperadmin, setIsSuperadmin] = useState(false);
    const [loggedUser, setLoggedUser] = useState(null);
    const [empresaId, setEmpresaId] = useState(null);
    const [categorias, setCategorias] = useState([]);

    // ==============================================
    // LOADING STATES
    // ==============================================
    const [createLoading, setCreateLoading] = useState(false);
    const [createMessage, setCreateMessage] = useState({ text: '', type: '' });
    const [editLoading, setEditLoading] = useState(false);
    const [editMessage, setEditMessage] = useState({ text: '', type: '' });

    // ==============================================
    // ESTATÍSTICAS
    // ==============================================
    const [stats, setStats] = useState({
        total: 0,
        ativos: 0,
        inativos: 0,
        precoMedio: 0,
        precoMaximo: 0,
        precoMinimo: 0,
        porTipoPreco: {}
    });

    // ==============================================
    // FILTROS AVANÇADOS
    // ==============================================
    const [filtros, setFiltros] = useState({
        categoria: 'todos',
        tipoPreco: 'todos',
        ativo: 'todos'
    });
    const [showFiltros, setShowFiltros] = useState(false);

    // ==============================================
    // FORM DATA - CRIAÇÃO
    // ==============================================
    const [formData, setFormData] = useState({
        nome: '',
        descricao: '',
        codigo: '',
        precoUnitario: '',
        precoVenda: '',
        tipoPreco: 'Fixo',
        duracaoEstimada: '',
        categoriaId: '',
        ativo: true,
        impostos: {
            iva: null,
            ispc: 0,
            usarIvaEmpresa: true
        }
    });

    // ==============================================
    // FORM DATA - EDIÇÃO
    // ==============================================
    const [editFormData, setEditFormData] = useState(null);

    // ==============================================
    // API INSTANCE
    // ==============================================
    const api = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Cache-Control': 'no-cache'
        }
    });

    // ==============================================
    // FUNÇÕES AUXILIARES
    // ==============================================
    const extrairEmpresaId = (empresa) => {
        if (!empresa) return null;
        if (typeof empresa === 'string') return empresa;
        if (typeof empresa === 'object' && empresa._id) return empresa._id;
        if (typeof empresa === 'object' && empresa.id) return empresa.id;
        return null;
    };

    const obterEmpresaIdDoUtilizador = (user) => {
        if (!user) return null;
        let id = extrairEmpresaId(user.empresaId);
        if (id) return id;
        id = extrairEmpresaId(user.empresa);
        if (id) return id;
        id = extrairEmpresaId(user.empresaAtual);
        if (id) return id;
        if (user.empresas && Array.isArray(user.empresas) && user.empresas.length > 0) {
            id = extrairEmpresaId(user.empresas[0]);
            if (id) return id;
        }
        return null;
    };

    const showTempToast = (title, message, type = 'success') => {
        setMessage({ text: `${title}: ${message}`, type });
        setTimeout(() => setMessage({ text: '', type: '' }), 4000);
    };

    // ==============================================
    // FORMATAÇÃO DE DATA/HORA
    // ==============================================
    const formatarDataHora = (data) => {
        if (!data) return '-';
        const d = new Date(data);
        const dia = String(d.getDate()).padStart(2, '0');
        const mes = String(d.getMonth() + 1).padStart(2, '0');
        const ano = d.getFullYear();
        const horas = String(d.getHours()).padStart(2, '0');
        const minutos = String(d.getMinutes()).padStart(2, '0');
        return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
    };

    // ==============================================
    // FORMATAÇÃO DE MOEDA (usa configEmpresa.moeda)
    // ==============================================
    const formatarMoeda = (valor) => {
        const moeda = configEmpresa?.moeda || CONFIG_PADRAO.moeda;
        const {
            simbolo = 'MT',
            casasDecimais = 2,
            separadorDecimal = ',',
            separadorMilhar = '.',
            posicaoSimbolo = 'depois'
        } = moeda;

        if (valor === undefined || valor === null || isNaN(valor)) {
            const zeros = `0${separadorDecimal}${'0'.repeat(casasDecimais)}`;
            return posicaoSimbolo === 'antes' ? `${simbolo} ${zeros}` : `${zeros} ${simbolo}`;
        }

        let numero = Number(valor);
        if (isNaN(numero)) {
            const zeros = `0${separadorDecimal}${'0'.repeat(casasDecimais)}`;
            return posicaoSimbolo === 'antes' ? `${simbolo} ${zeros}` : `${zeros} ${simbolo}`;
        }

        numero = numero.toFixed(casasDecimais);
        const partes = numero.split('.');
        let inteiros = partes[0];
        const decimais = partes[1] || '0'.repeat(casasDecimais);

        inteiros = inteiros.replace(/\B(?=(\d{3})+(?!\d))/g, separadorMilhar);

        const base = `${inteiros}${separadorDecimal}${decimais}`;
        return posicaoSimbolo === 'antes' ? `${simbolo} ${base}` : `${base} ${simbolo}`;
    };

    const formatarNumero = (valor) => {
        if (valor === undefined || valor === null) return '0';
        const num = Number(valor);
        if (isNaN(num)) return '0';

        if (num >= 1e9) return (num / 1e9).toFixed(1) + 'B';
        if (num >= 1e6) return (num / 1e6).toFixed(1) + 'M';
        if (num >= 1e3) return (num / 1e3).toFixed(1) + 'k';

        return num.toLocaleString('pt-PT');
    };

    // ==============================================
    // CÁLCULOS DE IVA
    // ==============================================
    const calcularPrecoComIVA = (precoSemIVA, iva) => {
        if (!precoSemIVA || precoSemIVA <= 0) return null;
        if (iva === null || iva === undefined || iva === 0) return precoSemIVA;
        const taxaIVA = Number(iva) / 100;
        return precoSemIVA * (1 + taxaIVA);
    };

    const calcularPrecoSemIVA = (precoComIVA, iva) => {
        if (!precoComIVA || precoComIVA <= 0) return null;
        if (iva === null || iva === undefined || iva === 0) return precoComIVA;
        const taxaIVA = Number(iva) / 100;
        return precoComIVA / (1 + taxaIVA);
    };

    const getIvaEfetivo = (impostos) => {
        if (!impostos) return null;

        if (impostos.usarIvaEmpresa) {
            return configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? configEmpresa.iva : null;
        }

        return impostos.iva !== null && impostos.iva !== undefined ? impostos.iva : null;
    };

    const sanitizarPreco = (valor) => {
        if (!valor) return '';
        let val = valor.replace(/[^0-9.]/g, '');
        const partes = val.split('.');
        if (partes.length > 2) {
            val = partes[0] + '.' + partes.slice(1).join('');
        }
        if (val.startsWith('.')) {
            val = '0' + val;
        }
        return val;
    };

    // ==============================================
    // BADGES
    // ==============================================
    const getStatusBadge = (ativo) => {
        return ativo
            ? { label: 'Ativo', color: '#10b981', icon: 'check_circle', class: 'active' }
            : { label: 'Inativo', color: '#dc2626', icon: 'block', class: 'inactive' };
    };

    const getTipoPrecoLabel = (value) => {
        const found = TIPOS_PRECO.find(t => t.value === value);
        return found ? found.label : value || '-';
    };

    const ordenarServicos = (lista) => {
        return [...lista].sort((a, b) => {
            const dataA = a.createdAt ? new Date(a.createdAt) : new Date(0);
            const dataB = b.createdAt ? new Date(b.createdAt) : new Date(0);
            return dataB.getTime() - dataA.getTime();
        });
    };

    // ==============================================
    // BUSCAR SERVIÇOS
    // ==============================================
    const fetchServicos = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }

            const response = await api.get('/servicos');

            let servicosData = [];
            let config = { ...CONFIG_PADRAO };

            if (response.data) {
                if (response.data.data && Array.isArray(response.data.data)) {
                    servicosData = response.data.data;
                    if (response.data.configuracao) {
                        config = {
                            ...CONFIG_PADRAO,
                            ...response.data.configuracao,
                            moeda: {
                                ...CONFIG_PADRAO.moeda,
                                ...(response.data.configuracao.moeda || {})
                            }
                        };
                        if (response.data.configuracao.iva !== undefined && response.data.configuracao.iva !== null) {
                            config.iva = response.data.configuracao.iva;
                        } else {
                            config.iva = null;
                        }
                    }
                } else if (Array.isArray(response.data)) {
                    servicosData = response.data;
                }
            }

            console.log('🔍 [fetchServicos] config recebida do backend:', config);

            // 🔥 Só atualiza a config se ainda não temos uma "boa" ou se esta é melhor
            setConfigEmpresa(prev => {
                const novaConfig = { ...prev, ...config, moeda: { ...prev.moeda, ...config.moeda } };
                console.log('🔍 [fetchServicos] config aplicada:', novaConfig);
                return novaConfig;
            });

            const servicosOrdenados = ordenarServicos(servicosData);
            setServicos(servicosOrdenados);
            setFilteredServicos(servicosOrdenados);
            calcularStats(servicosOrdenados);
            setPagination({
                ...pagination,
                total: servicosOrdenados.length,
                pages: Math.ceil(servicosOrdenados.length / pagination.limit),
                page: 1
            });
        } catch (err) {
            console.error('❌ Erro ao carregar serviços:', err);
            showTempToast('Erro', 'Não foi possível carregar os serviços', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // ==============================================
    // BUSCAR CATEGORIAS
    // ==============================================
    const fetchCategorias = async () => {
        try {
            const response = await api.get('/categorias');
            if (response.data) {
                const categoriasData = Array.isArray(response.data) ? response.data : response.data.data || [];
                setCategorias(categoriasData);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar categorias:', err);
        }
    };

    // ==============================================
    // 🔥 BUSCAR CONFIGURAÇÃO DA EMPRESA (moeda + IVA + formatação)
    //    CORRIGIDO: recebe `userParam` para não depender do state
    // ==============================================
    const fetchConfigEmpresa = async (userParam = null) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return;

            // 🔥 Usar o user passado, ou o state, ou o localStorage
            const user = userParam
                || loggedUser
                || JSON.parse(localStorage.getItem('usuario') || '{}');

            const empresaIdLocal = empresaId || obterEmpresaIdDoUtilizador(user);

            console.log('🔍 [fetchConfigEmpresa] user:', user?.nome, 'empresaIdLocal:', empresaIdLocal);

            if (!empresaIdLocal) {
                console.warn('⚠️ [fetchConfigEmpresa] Sem empresa, a usar CONFIG_PADRAO');
                return;
            }

            const response = await api.get(`/empresas/${empresaIdLocal}/config`);
            console.log('🔍 [fetchConfigEmpresa] resposta:', response.data);

            if (response.data && response.data.success) {
                const config = response.data.data || {};
                console.log('✅ [fetchConfigEmpresa] config recebida:', config);

                setConfigEmpresa(prev => {
                    const nova = {
                        ...prev,
                        ...config,
                        moeda: {
                            ...prev.moeda,
                            ...(config.moeda || {})
                        },
                        iva: config.iva !== undefined ? config.iva : prev.iva
                    };
                    console.log('✅ [fetchConfigEmpresa] config aplicada:', nova);
                    return nova;
                });
            }
        } catch (err) {
            console.warn('⚠️ [fetchConfigEmpresa] Falha ao carregar config da empresa:', err.message);

            // 🔥 Fallback: tenta buscar o IVA do localStorage
            try {
                const user = userParam || loggedUser || JSON.parse(localStorage.getItem('usuario') || '{}');
                if (user?.empresaId && typeof user.empresaId === 'object') {
                    const emp = user.empresaId;
                    if (emp.moeda || emp.configuracoes?.moeda) {
                        setConfigEmpresa(prev => ({
                            ...prev,
                            moeda: {
                                ...prev.moeda,
                                ...(emp.moeda || emp.configuracoes?.moeda || {})
                            },
                            iva: emp.percentagemIVA ?? prev.iva
                        }));
                    }
                }
            } catch (e) {
                // ignora
            }
        }
    };

    // ==============================================
    // BUSCAR USUÁRIO LOGADO
    // ==============================================
    const fetchLoggedUser = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                const storedUser = JSON.parse(localStorage.getItem('usuario') || '{}');
                if (storedUser && storedUser._id) {
                    setLoggedUser(storedUser);
                    setIsSuperadmin(storedUser.perfil === 'Superadmin');
                    const empresaIdExtraido = obterEmpresaIdDoUtilizador(storedUser);
                    setEmpresaId(empresaIdExtraido);
                    return storedUser;
                }
                return null;
            }

            const response = await axios.get(`${API_BASE_URL}/users/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                const userData = response.data.data;
                setLoggedUser(userData);
                setIsSuperadmin(userData.perfil === 'Superadmin');
                const empresaIdExtraido = obterEmpresaIdDoUtilizador(userData);
                setEmpresaId(empresaIdExtraido);
                localStorage.setItem('usuario', JSON.stringify(userData));
                return userData;
            }
        } catch (err) {
            console.error('❌ Erro ao buscar utilizador:', err);
        }
        return null;
    };

    // ==============================================
    // CALCULAR ESTATÍSTICAS
    // ==============================================
    const calcularStats = (servicosData) => {
        const data = Array.isArray(servicosData) ? servicosData : [];

        const ativos = data.filter(s => s.ativo !== false);
        const inativos = data.filter(s => s.ativo === false);
        const precoMedio = data.length > 0
            ? data.reduce((sum, s) => sum + (s.precoVenda || 0), 0) / data.length
            : 0;
        const precoMaximo = data.length > 0
            ? Math.max(...data.map(s => s.precoVenda || 0))
            : 0;
        const precoMinimo = data.length > 0
            ? Math.min(...data.map(s => s.precoVenda || 0))
            : 0;

        const porTipoPreco = {};
        data.forEach(s => {
            const tipo = s.tipoPreco || 'Fixo';
            porTipoPreco[tipo] = (porTipoPreco[tipo] || 0) + 1;
        });

        setStats({
            total: data.length,
            ativos: ativos.length,
            inativos: inativos.length,
            precoMedio,
            precoMaximo,
            precoMinimo,
            porTipoPreco
        });
    };

    // ==============================================
    // FILTRAR SERVIÇOS
    // ==============================================
    useEffect(() => {
        filtrarServicos();
    }, [searchTerm, servicos, filtros]);

    const filtrarServicos = () => {
        let resultados = [...servicos];

        if (searchTerm && searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase().trim();
            resultados = resultados.filter(s => {
                const nome = s.nome || '';
                const codigo = s.codigo || '';
                const descricao = s.descricao || '';
                const categoria = s.categoriaId?.nome || '';

                return nome.toLowerCase().includes(term) ||
                    codigo.toLowerCase().includes(term) ||
                    descricao.toLowerCase().includes(term) ||
                    categoria.toLowerCase().includes(term);
            });
        }

        if (filtros.categoria && filtros.categoria !== 'todos') {
            resultados = resultados.filter(s =>
                s.categoriaId?._id === filtros.categoria ||
                s.categoriaId === filtros.categoria
            );
        }

        if (filtros.tipoPreco && filtros.tipoPreco !== 'todos') {
            resultados = resultados.filter(s => s.tipoPreco === filtros.tipoPreco);
        }

        if (filtros.ativo && filtros.ativo !== 'todos') {
            const isAtivo = filtros.ativo === 'ativo';
            resultados = resultados.filter(s => s.ativo === isAtivo);
        }

        resultados = ordenarServicos(resultados);

        setFilteredServicos(resultados);
        calcularStats(resultados);
        setPagination(prev => ({
            ...prev,
            total: resultados.length,
            pages: Math.ceil(resultados.length / prev.limit),
            page: 1
        }));
    };

    const limparFiltros = () => {
        setFiltros({
            categoria: 'todos',
            tipoPreco: 'todos',
            ativo: 'todos'
        });
        setSearchTerm('');
        setShowFiltros(false);
    };

    // ==============================================
    // CARREGAR DADOS INICIAIS
    // ==============================================
    useEffect(() => {
        const carregarDados = async () => {
            const user = await fetchLoggedUser();
            if (user) {
                // 🔥 Passa o user diretamente para não depender do state
                await fetchConfigEmpresa(user);
            }
            await Promise.all([
                fetchServicos(),
                fetchCategorias()
            ]);
        };
        carregarDados();
    }, []);

    // ==============================================
    // 🔥 RECARREGAR CONFIG QUANDO O empresaId MUDAR
    //    (garante que se o fetchLoggedUser for lento, a config é carregada)
    // ==============================================
    useEffect(() => {
        if (empresaId) {
            console.log('🔍 [useEffect empresaId] empresaId mudou:', empresaId);
            fetchConfigEmpresa();
        }
    }, [empresaId]);

    // ==============================================
    // 🔥 EFECTO PARA CALCULAR PREÇO DE VENDA (CRIAÇÃO)
    // ==============================================
    const isUpdatingPrice = useRef(false);

    useEffect(() => {
        if (isUpdatingPrice.current) return;

        const precoUnitario = parseFloat(formData.precoUnitario) || 0;
        const ivaEfetivo = getIvaEfetivo(formData.impostos);

        if (precoUnitario > 0 && ivaEfetivo !== null && ivaEfetivo !== undefined) {
            const precoComIva = calcularPrecoComIVA(precoUnitario, ivaEfetivo);

            if (precoComIva !== null) {
                isUpdatingPrice.current = true;
                setFormData(prev => ({
                    ...prev,
                    precoVenda: Math.round(precoComIva * 100) / 100
                }));
                setTimeout(() => {
                    isUpdatingPrice.current = false;
                }, 100);
            }
        } else if (precoUnitario > 0 && (ivaEfetivo === null || ivaEfetivo === undefined)) {
            isUpdatingPrice.current = true;
            setFormData(prev => ({
                ...prev,
                precoVenda: precoUnitario
            }));
            setTimeout(() => {
                isUpdatingPrice.current = false;
            }, 100);
        }
    }, [formData.precoUnitario, formData.impostos.iva, formData.impostos.usarIvaEmpresa, configEmpresa.iva]);

    // ==============================================
    // 🔥 EFECTO PARA CALCULAR PREÇO DE VENDA (EDIÇÃO)
    // ==============================================
    const isUpdatingEditPrice = useRef(false);

    useEffect(() => {
        if (!editFormData) return;
        if (isUpdatingEditPrice.current) return;

        const precoUnitario = parseFloat(editFormData.precoUnitario) || 0;
        const ivaEfetivo = getIvaEfetivo(editFormData.impostos);

        if (precoUnitario > 0 && ivaEfetivo !== null && ivaEfetivo !== undefined) {
            const precoComIva = calcularPrecoComIVA(precoUnitario, ivaEfetivo);

            if (precoComIva !== null) {
                isUpdatingEditPrice.current = true;
                setEditFormData(prev => ({
                    ...prev,
                    precoVenda: Math.round(precoComIva * 100) / 100
                }));
                setTimeout(() => {
                    isUpdatingEditPrice.current = false;
                }, 100);
            }
        } else if (precoUnitario > 0 && (ivaEfetivo === null || ivaEfetivo === undefined)) {
            isUpdatingEditPrice.current = true;
            setEditFormData(prev => ({
                ...prev,
                precoVenda: precoUnitario
            }));
            setTimeout(() => {
                isUpdatingEditPrice.current = false;
            }, 100);
        }
    }, [editFormData?.precoUnitario, editFormData?.impostos?.iva, editFormData?.impostos?.usarIvaEmpresa, configEmpresa.iva]);

    // ==============================================
    // HANDLE CHANGE - CRIAÇÃO
    // ==============================================
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name.startsWith('impostos.')) {
            const field = name.split('.')[1];

            if (field === 'iva') {
                const val = value === '' ? null : value;
                setFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            } else if (field === 'usarIvaEmpresa') {
                setFormData(prev => ({
                    ...prev,
                    impostos: {
                        ...prev.impostos,
                        [field]: checked,
                        iva: checked ? null : prev.impostos.iva
                    }
                }));
            } else {
                const val = type === 'checkbox' ? checked : value;
                setFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            }
        } else if (name === 'precoUnitario') {
            const val = sanitizarPreco(value);
            setFormData(prev => ({ ...prev, [name]: val }));
        } else if (name === 'precoVenda') {
            const val = sanitizarPreco(value);
            setFormData(prev => ({ ...prev, [name]: val }));
        } else {
            const val = type === 'checkbox' ? checked : value;
            setFormData(prev => ({ ...prev, [name]: val }));
        }
    };

    // ==============================================
    // HANDLE CHANGE - EDIÇÃO
    // ==============================================
    const handleEditChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name.startsWith('impostos.')) {
            const field = name.split('.')[1];

            if (field === 'iva') {
                const val = value === '' ? null : value;
                setEditFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            } else if (field === 'usarIvaEmpresa') {
                setEditFormData(prev => ({
                    ...prev,
                    impostos: {
                        ...prev.impostos,
                        [field]: checked,
                        iva: checked ? null : prev.impostos.iva
                    }
                }));
            } else {
                const val = type === 'checkbox' ? checked : value;
                setEditFormData(prev => ({
                    ...prev,
                    impostos: { ...prev.impostos, [field]: val }
                }));
            }
        } else if (name === 'precoUnitario') {
            const val = sanitizarPreco(value);
            setEditFormData(prev => ({ ...prev, [name]: val }));
        } else if (name === 'precoVenda') {
            const val = sanitizarPreco(value);
            setEditFormData(prev => ({ ...prev, [name]: val }));
        } else {
            const val = type === 'checkbox' ? checked : value;
            setEditFormData(prev => ({ ...prev, [name]: val }));
        }
    };

    // ==============================================
    // RESET FORM
    // ==============================================
    const resetForm = () => {
        setFormData({
            nome: '',
            descricao: '',
            codigo: '',
            precoUnitario: '',
            precoVenda: '',
            tipoPreco: 'Fixo',
            duracaoEstimada: '',
            categoriaId: '',
            ativo: true,
            impostos: {
                iva: null,
                ispc: 0,
                usarIvaEmpresa: true
            }
        });
        setCreateMessage({ text: '', type: '' });
        setActiveTab('geral');
    };

    const resetEditForm = () => {
        setEditFormData(null);
        setEditMessage({ text: '', type: '' });
        setEditActiveTab('geral');
    };

    // ==============================================
    // CRIAÇÃO
    // ==============================================
    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        setCreateLoading(true);
        setCreateMessage({ text: '', type: '' });

        if (!formData.nome.trim()) {
            setCreateMessage({ text: 'O nome do serviço é obrigatório', type: 'danger' });
            setCreateLoading(false);
            return;
        }

        if (!formData.precoVenda || parseFloat(formData.precoVenda) <= 0) {
            setCreateMessage({ text: 'Preço de venda inválido', type: 'danger' });
            setCreateLoading(false);
            return;
        }

        let empresaParaEnviar = empresaId;
        if (!empresaParaEnviar && loggedUser) {
            empresaParaEnviar = obterEmpresaIdDoUtilizador(loggedUser);
        }

        if (!empresaParaEnviar) {
            setCreateMessage({
                text: 'Utilizador sem empresa associada. Contacte o administrador.',
                type: 'danger'
            });
            setCreateLoading(false);
            return;
        }

        let ivaEnviar = null;

        if (formData.impostos.usarIvaEmpresa) {
            ivaEnviar = null;
        } else {
            const ivaValue = formData.impostos.iva;
            if (ivaValue !== null && ivaValue !== undefined && ivaValue !== '') {
                ivaEnviar = Number(ivaValue);
            }
        }

        const dadosParaEnviar = {
            nome: formData.nome.trim(),
            descricao: formData.descricao?.trim() || '',
            codigo: formData.codigo?.trim() || '',
            precoVenda: parseFloat(formData.precoVenda) || 0,
            tipoPreco: formData.tipoPreco || 'Fixo',
            duracaoEstimada: formData.duracaoEstimada ? parseFloat(formData.duracaoEstimada) : null,
            categoriaId: formData.categoriaId || null,
            empresaId: empresaParaEnviar,
            ativo: formData.ativo !== undefined ? formData.ativo : true,
            impostos: {
                iva: ivaEnviar,
                ispc: parseFloat(formData.impostos.ispc) || 0,
                usarIvaEmpresa: formData.impostos.usarIvaEmpresa
            }
        };

        try {
            const response = await api.post('/servicos', dadosParaEnviar);

            if (response.data) {
                setCreateMessage({ text: 'Serviço criado com sucesso!', type: 'success' });
                setTimeout(() => {
                    setShowCreateModal(false);
                    resetForm();
                    fetchServicos();
                }, 1500);
            }
        } catch (err) {
            console.error('❌ Erro ao criar serviço:', err);
            setCreateMessage({
                text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao criar serviço',
                type: 'danger'
            });
        } finally {
            setCreateLoading(false);
        }
    };

    // ==============================================
    // VER DETALHES
    // ==============================================
    const verDetalhes = async (servico) => {
        try {
            setShowEditModal(false);
            setEditFormData(null);

            const response = await api.get(`/servicos/${servico._id}`);
            const servicoCompleto = response.data.data || servico;
            setServicoDetalhes(servicoCompleto);
            setDetailsActiveTab('dados');

            setTimeout(() => {
                setShowDetailsModal(true);
            }, 100);

        } catch (err) {
            console.error('❌ Erro ao buscar detalhes:', err);
            setServicoDetalhes(servico);
            setShowDetailsModal(true);
        }
    };

    // ==============================================
    // CARREGAR SERVIÇO PARA EDIÇÃO
    // ==============================================
    const loadServicoForEdit = async (servico) => {
        setEditLoading(true);
        try {
            setShowDetailsModal(false);
            setServicoDetalhes(null);

            const response = await api.get(`/servicos/${servico._id}`);
            const servicoCompleto = response.data.data || servico;

            const impostos = servicoCompleto.impostos || {};

            let ivaOriginal = null;
            if (impostos.iva !== undefined && impostos.iva !== null) {
                ivaOriginal = Number(impostos.iva);
            }

            let usarIvaEmpresa = true;
            if (impostos.usarIvaEmpresa !== undefined) {
                usarIvaEmpresa = impostos.usarIvaEmpresa;
            } else {
                usarIvaEmpresa = ivaOriginal === null;
            }

            const ivaEfetivo = getIvaEfetivo(servicoCompleto.impostos);
            const precoVenda = parseFloat(servicoCompleto.precoVenda) || 0;
            let precoUnitario = precoVenda;

            if (ivaEfetivo !== null && ivaEfetivo !== undefined && precoVenda > 0) {
                const precoSemIva = calcularPrecoSemIVA(precoVenda, ivaEfetivo);
                if (precoSemIva !== null) {
                    precoUnitario = precoSemIva;
                }
            }

            setEditFormData({
                _id: servicoCompleto._id,
                nome: servicoCompleto.nome || '',
                descricao: servicoCompleto.descricao || '',
                codigo: servicoCompleto.codigo || '',
                precoUnitario: precoUnitario > 0 ? Math.round(precoUnitario * 100) / 100 : '',
                precoVenda: servicoCompleto.precoVenda || '',
                tipoPreco: servicoCompleto.tipoPreco || 'Fixo',
                duracaoEstimada: servicoCompleto.duracaoEstimada || '',
                categoriaId: servicoCompleto.categoriaId?._id || servicoCompleto.categoriaId || '',
                ativo: servicoCompleto.ativo !== undefined ? servicoCompleto.ativo : true,
                impostos: {
                    iva: ivaOriginal,
                    ispc: impostos.ispc || 0,
                    usarIvaEmpresa: usarIvaEmpresa
                }
            });

            setEditActiveTab('geral');

            setTimeout(() => {
                setShowEditModal(true);
            }, 100);

        } catch (error) {
            console.error('Erro ao carregar serviço:', error);
            setEditMessage({ text: 'Erro ao carregar dados do serviço', type: 'danger' });
        } finally {
            setEditLoading(false);
        }
    };

    const handleEdit = (servico) => {
        loadServicoForEdit(servico);
    };

    // ==============================================
    // EDIÇÃO
    // ==============================================
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditLoading(true);
        setEditMessage({ text: '', type: '' });

        if (!editFormData.nome.trim()) {
            setEditMessage({ text: 'O nome do serviço é obrigatório', type: 'danger' });
            setEditLoading(false);
            return;
        }

        if (!editFormData.precoVenda || parseFloat(editFormData.precoVenda) <= 0) {
            setEditMessage({ text: 'Preço de venda inválido', type: 'danger' });
            setEditLoading(false);
            return;
        }

        try {
            const { _id, ...updateData } = editFormData;

            let ivaEnviar = null;

            if (editFormData.impostos.usarIvaEmpresa) {
                ivaEnviar = null;
            } else {
                const ivaValue = editFormData.impostos.iva;
                if (ivaValue !== null && ivaValue !== undefined && ivaValue !== '') {
                    ivaEnviar = Number(ivaValue);
                }
            }

            const dadosParaEnviar = {
                nome: updateData.nome,
                descricao: updateData.descricao || '',
                precoVenda: parseFloat(updateData.precoVenda) || 0,
                tipoPreco: updateData.tipoPreco || 'Fixo',
                duracaoEstimada: updateData.duracaoEstimada ? parseFloat(updateData.duracaoEstimada) : null,
                categoriaId: updateData.categoriaId || null,
                ativo: updateData.ativo,
                impostos: {
                    iva: ivaEnviar,
                    ispc: parseFloat(editFormData.impostos.ispc) || 0,
                    usarIvaEmpresa: editFormData.impostos.usarIvaEmpresa
                }
            };

            const response = await api.put(`/servicos/${_id}`, dadosParaEnviar);

            if (response.data) {
                setEditMessage({ text: 'Serviço atualizado com sucesso!', type: 'success' });
                setTimeout(() => {
                    setShowEditModal(false);
                    resetEditForm();
                    fetchServicos();
                }, 1500);
            }
        } catch (err) {
            console.error('❌ Erro ao atualizar serviço:', err);
            setEditMessage({
                text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao atualizar serviço',
                type: 'danger'
            });
        } finally {
            setEditLoading(false);
        }
    };

    // ==============================================
    // EXCLUSÃO
    // ==============================================
    const openDeleteModal = (servico) => {
        setServicoToDelete(servico);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setServicoToDelete(null);
    };

    const confirmDelete = async () => {
        if (!servicoToDelete) return;

        try {
            const response = await api.delete(`/servicos/${servicoToDelete._id}`);
            if (response.data) {
                showTempToast('Sucesso', `Serviço "${servicoToDelete.nome}" removido com sucesso!`, 'success');
                closeDeleteModal();
                fetchServicos();
            }
        } catch (err) {
            console.error('❌ Erro ao remover serviço:', err);
            showTempToast('Erro', err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao remover serviço', 'danger');
        }
    };

    // ==============================================
    // EXPORTAÇÃO
    // ==============================================
    const exportarServicos = async (formato) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada. Faça login novamente.', 'danger');
                return;
            }

            const params = new URLSearchParams();
            params.append('formato', formato);
            if (searchTerm) params.append('search', searchTerm);
            if (filtros.categoria && filtros.categoria !== 'todos') params.append('categoria', filtros.categoria);
            if (filtros.tipoPreco && filtros.tipoPreco !== 'todos') params.append('tipoPreco', filtros.tipoPreco);
            if (filtros.ativo && filtros.ativo !== 'todos') params.append('ativo', filtros.ativo);

            const url = `/api/servicos/exportar?${params.toString()}`;
            console.log('📤 Exportando serviços para:', url);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || errorData.erro || 'Erro na exportação');
            }

            const blob = await response.blob();
            const extensao = formato === 'excel' || formato === 'xlsx' ? 'xlsx' : 'csv';

            const urlDownload = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlDownload;
            link.download = `servicos_${new Date().toISOString().split('T')[0]}.${extensao}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlDownload);

            showTempToast('Sucesso', `Serviços exportados em ${formato.toUpperCase()}`, 'success');
        } catch (err) {
            console.error('❌ Erro na exportação:', err);
            showTempToast('Erro', err.message || 'Falha na exportação', 'danger');
        }
    };

    // ==============================================
    // PAGINAÇÃO
    // ==============================================
    const getCurrentPageServicos = () => {
        const startIndex = (pagination.page - 1) * pagination.limit;
        const endIndex = startIndex + pagination.limit;
        return filteredServicos.slice(startIndex, endIndex);
    };

    const goToPage = (page) => {
        if (page < 1 || page > pagination.pages) return;
        setPagination({ ...pagination, page });
    };

    const renderPagination = () => {
        const { page, pages, total } = pagination;
        if (pages <= 1) return null;

        const startItem = (page - 1) * pagination.limit + 1;
        const endItem = Math.min(page * pagination.limit, total);

        return (
            <div className="servicos-pagination">
                <div className="pagination-info">
                    <span>Mostrando {startItem} - {endItem} de {total} serviços</span>
                </div>
                <div className="pagination-controls">
                    <button className="pagination-btn" onClick={() => goToPage(page - 1)} disabled={page === 1}>
                        <Icon name="chevron_left" size={18} />
                    </button>
                    <div className="pagination-numbers">
                        {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
                            <button
                                key={p}
                                className={`pagination-number ${page === p ? 'active' : ''}`}
                                onClick={() => goToPage(p)}
                            >
                                {p}
                            </button>
                        ))}
                    </div>
                    <button className="pagination-btn" onClick={() => goToPage(page + 1)} disabled={page === pages}>
                        <Icon name="chevron_right" size={18} />
                    </button>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER PRINCIPAL
    // ==============================================
    const currentServicos = getCurrentPageServicos();

    const precoUnitarioAtual = parseFloat(formData.precoUnitario) || 0;
    const ivaEfetivo = getIvaEfetivo(formData.impostos);
    const precoVendaCalculado = calcularPrecoComIVA(precoUnitarioAtual, ivaEfetivo);

    const precoUnitarioEdit = editFormData ? parseFloat(editFormData.precoUnitario) || 0 : 0;
    const ivaEfetivoEdit = editFormData ? getIvaEfetivo(editFormData.impostos) : null;
    const precoVendaCalculadoEdit = calcularPrecoComIVA(precoUnitarioEdit, ivaEfetivoEdit);

    return (
        <div className="servicos-container">
    {/* MODAL DE CRIAÇÃO */}
    {showCreateModal && (
        <div className="servico-modal-overlay" onClick={() => { setShowCreateModal(false); resetForm(); }}>
            <div className="servico-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="servico-modal-header">
                    <h3><Icon name="add_box" size={22} /> Novo Serviço</h3>
                    <button className="servico-modal-close" onClick={() => { setShowCreateModal(false); resetForm(); }}>×</button>
                </div>
                <div className="servico-modal-body">
                    {createMessage.text && (
                        <div className={`servico-modal-alert servico-modal-alert-${createMessage.type}`}>
                            <Icon name={createMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                            <span>{createMessage.text}</span>
                            <button className="servico-alert-close" onClick={() => setCreateMessage({ text: '', type: '' })}>×</button>
                        </div>
                    )}
                    <form onSubmit={handleCreateSubmit}>
                        <div className="servico-modal-tabs">
                            <button type="button" className={`servico-modal-tab-btn ${activeTab === 'geral' ? 'active' : ''}`} onClick={() => setActiveTab('geral')}>
                                <Icon name="info" size={16} />
                                <span className="tab-label">Dados Gerais</span>
                            </button>
                            <button type="button" className={`servico-modal-tab-btn ${activeTab === 'impostos' ? 'active' : ''}`} onClick={() => setActiveTab('impostos')}>
                                <Icon name="receipt" size={16} />
                                <span className="tab-label">Impostos</span>
                            </button>
                        </div>

                        <div className={`servico-modal-tab-panel ${activeTab === 'geral' ? 'active' : ''}`}>
                            <div className="servico-modal-section">
                                <div className="servico-form-group">
                                    <label>Nome <span className="servico-required">*</span></label>
                                    <input type="text" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Nome do serviço" />
                                </div>
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>Código</label>
                                        <input type="text" name="codigo" value={formData.codigo} onChange={handleChange} placeholder="Código (opcional)" />
                                        <small className="servico-form-help">O código será gerado automaticamente com prefixo SR</small>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>Categoria</label>
                                        <select name="categoriaId" value={formData.categoriaId} onChange={handleChange}>
                                            <option value="">Selecione uma categoria</option>
                                            {categorias.map(cat => (
                                                <option key={cat._id} value={cat._id}>{cat.nome}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>Preço Unitário <span className="servico-required">*</span></label>
                                        <input
                                            type="text"
                                            name="precoUnitario"
                                            value={formData.precoUnitario}
                                            onChange={handleChange}
                                            required
                                            placeholder="0.00"
                                            inputMode="decimal"
                                            autoComplete="off"
                                        />
                                        <small className="servico-form-help">Preço base sem IVA</small>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>Preço de Venda (com IVA)</label>
                                        <input
                                            type="text"
                                            name="precoVenda"
                                            value={formData.precoVenda}
                                            onChange={handleChange}
                                            placeholder="0.00"
                                            inputMode="decimal"
                                            autoComplete="off"
                                            readOnly
                                            
                                        />
                                        {ivaEfetivo !== null && ivaEfetivo !== undefined && precoUnitarioAtual > 0 && (
                                            <small className="servico-form-help" style={{ color: 'var(--color-info)' }}>
                                                <Icon name="info" size={12} style={{ marginRight: '0.3rem' }} />
                                                Calculado com IVA de {ivaEfetivo}% (base: {formatarMoeda(precoUnitarioAtual)})
                                            </small>
                                        )}
                                        {ivaEfetivo === null && precoUnitarioAtual > 0 && (
                                            <small className="servico-form-help" style={{ color: 'var(--color-warning)' }}>
                                                <Icon name="warning" size={12} style={{ marginRight: '0.3rem' }} />
                                                Sem IVA configurado
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>Tipo de Preço</label>
                                        <select name="tipoPreco" value={formData.tipoPreco} onChange={handleChange}>
                                            {TIPOS_PRECO.map(t => (
                                                <option key={t.value} value={t.value}>{t.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>Duração Estimada (horas)</label>
                                        <input type="number" name="duracaoEstimada" value={formData.duracaoEstimada} onChange={handleChange} placeholder="Ex: 2.5" step="0.5" min="0" />
                                        <small className="servico-form-help">Deixe em branco se não aplicável</small>
                                    </div>
                                </div>
                                <div className="servico-form-group">
                                    <label>Descrição</label>
                                    <textarea name="descricao" value={formData.descricao} onChange={handleChange} placeholder="Descrição do serviço" rows="2" />
                                </div>
                                <div className="servico-form-group">
                                    <label className="servico-checkbox-label">
                                        <input type="checkbox" name="ativo" checked={formData.ativo} onChange={handleChange} />
                                        Serviço Ativo
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className={`servico-modal-tab-panel ${activeTab === 'impostos' ? 'active' : ''}`}>
                            <div className="servico-modal-section">
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>IVA (%)</label>
                                        <input
                                            type="number"
                                            name="impostos.iva"
                                            value={formData.impostos.iva !== null && formData.impostos.iva !== undefined ? formData.impostos.iva : ''}
                                            onChange={handleChange}
                                            placeholder="Deixar em branco para usar o da empresa"
                                            step="0.01"
                                            min="0"
                                            max="100"
                                            disabled={formData.impostos.usarIvaEmpresa}
                                        />
                                        <small className="servico-form-help">
                                            {formData.impostos.usarIvaEmpresa
                                                ? `Usando IVA da empresa (${configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})`
                                                : formData.impostos.iva !== null ? `IVA específico: ${formData.impostos.iva}%` : 'IVA específico do serviço'}
                                        </small>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>ISPC (%)</label>
                                        <input type="number" name="impostos.ispc" value={formData.impostos.ispc || 0} onChange={handleChange} placeholder="0" step="0.01" min="0" max="100" />
                                    </div>
                                </div>
                                <div className="servico-form-group">
                                    <label className="servico-checkbox-label">
                                        <input
                                            type="checkbox"
                                            name="impostos.usarIvaEmpresa"
                                            checked={formData.impostos.usarIvaEmpresa}
                                            onChange={handleChange}
                                        />
                                        Usar IVA da empresa ({configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="servico-modal-actions">
                            <button type="submit" className="servico-modal-btn-primary" disabled={createLoading}>
                                {createLoading ? 'A criar...' : 'Criar Serviço'}
                            </button>
                            <button type="button" className="servico-modal-btn-secondary" onClick={resetForm}>Limpar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )}

    {/* MODAL DE EDIÇÃO */}
    {showEditModal && editFormData && (
        <div className="servico-modal-overlay" onClick={() => { setShowEditModal(false); resetEditForm(); }}>
            <div className="servico-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="servico-modal-header">
                    <h3><Icon name="edit" size={22} /> Editar Serviço</h3>
                    <button className="servico-modal-close" onClick={() => { setShowEditModal(false); resetEditForm(); }}>×</button>
                </div>
                <div className="servico-modal-body">
                    {editMessage.text && (
                        <div className={`servico-modal-alert servico-modal-alert-${editMessage.type}`}>
                            <Icon name={editMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                            <span>{editMessage.text}</span>
                            <button className="servico-alert-close" onClick={() => setEditMessage({ text: '', type: '' })}>×</button>
                        </div>
                    )}
                    <form onSubmit={handleEditSubmit}>
                        <div className="servico-modal-tabs">
                            <button type="button" className={`servico-modal-tab-btn ${editActiveTab === 'geral' ? 'active' : ''}`} onClick={() => setEditActiveTab('geral')}>
                                <Icon name="info" size={16} />
                                <span className="tab-label">Dados Gerais</span>
                            </button>
                            <button type="button" className={`servico-modal-tab-btn ${editActiveTab === 'impostos' ? 'active' : ''}`} onClick={() => setEditActiveTab('impostos')}>
                                <Icon name="receipt" size={16} />
                                <span className="tab-label">Impostos</span>
                            </button>
                        </div>

                        <div className={`servico-modal-tab-panel ${editActiveTab === 'geral' ? 'active' : ''}`}>
                            <div className="servico-modal-section">
                                <div className="servico-form-group">
                                    <label>Nome <span className="servico-required">*</span></label>
                                    <input type="text" name="nome" value={editFormData.nome} onChange={handleEditChange} required placeholder="Nome do serviço" />
                                </div>
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>Código</label>
                                        <input type="text" name="codigo" value={editFormData.codigo} onChange={handleEditChange} placeholder="Código" disabled />
                                    </div>
                                    <div className="servico-form-group">
                                        <label>Categoria</label>
                                        <select name="categoriaId" value={editFormData.categoriaId} onChange={handleEditChange}>
                                            <option value="">Selecione uma categoria</option>
                                            {categorias.map(cat => (
                                                <option key={cat._id} value={cat._id}>{cat.nome}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>Preço Unitário <span className="servico-required">*</span></label>
                                        <input
                                            type="text"
                                            name="precoUnitario"
                                            value={editFormData.precoUnitario}
                                            onChange={handleEditChange}
                                            required
                                            placeholder="0.00"
                                            inputMode="decimal"
                                            autoComplete="off"
                                        />
                                        <small className="servico-form-help">Preço base sem IVA</small>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>Preço de Venda (com IVA)</label>
                                        <input
                                            type="text"
                                            name="precoVenda"
                                            value={editFormData.precoVenda}
                                            onChange={handleEditChange}
                                            placeholder="0.00"
                                            inputMode="decimal"
                                            autoComplete="off"
                                            readOnly
                                            
                                        />
                                        {ivaEfetivoEdit !== null && ivaEfetivoEdit !== undefined && precoUnitarioEdit > 0 && (
                                            <small className="servico-form-help" style={{ color: 'var(--color-info)' }}>
                                                <Icon name="info" size={12} style={{ marginRight: '0.3rem' }} />
                                                Calculado com IVA de {ivaEfetivoEdit}% (base: {formatarMoeda(precoUnitarioEdit)})
                                            </small>
                                        )}
                                        {ivaEfetivoEdit === null && precoUnitarioEdit > 0 && (
                                            <small className="servico-form-help" style={{ color: 'var(--color-warning)' }}>
                                                <Icon name="warning" size={12} style={{ marginRight: '0.3rem' }} />
                                                Sem IVA configurado
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>Tipo de Preço</label>
                                        <select name="tipoPreco" value={editFormData.tipoPreco} onChange={handleEditChange}>
                                            {TIPOS_PRECO.map(t => (
                                                <option key={t.value} value={t.value}>{t.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>Duração Estimada (horas)</label>
                                        <input type="number" name="duracaoEstimada" value={editFormData.duracaoEstimada} onChange={handleEditChange} placeholder="Ex: 2.5" step="0.5" min="0" />
                                    </div>
                                </div>
                                <div className="servico-form-group">
                                    <label>Descrição</label>
                                    <textarea name="descricao" value={editFormData.descricao} onChange={handleEditChange} placeholder="Descrição do serviço" rows="2" />
                                </div>
                                <div className="servico-form-group">
                                    <label className="servico-checkbox-label">
                                        <input type="checkbox" name="ativo" checked={editFormData.ativo} onChange={handleEditChange} />
                                        Serviço Ativo
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className={`servico-modal-tab-panel ${editActiveTab === 'impostos' ? 'active' : ''}`}>
                            <div className="servico-modal-section">
                                <div className="servico-form-row">
                                    <div className="servico-form-group">
                                        <label>IVA (%)</label>
                                        <input
                                            type="number"
                                            name="impostos.iva"
                                            value={editFormData.impostos.iva !== null && editFormData.impostos.iva !== undefined ? editFormData.impostos.iva : ''}
                                            onChange={handleEditChange}
                                            placeholder="Deixar em branco para usar o da empresa"
                                            step="0.01"
                                            min="0"
                                            max="100"
                                            disabled={editFormData.impostos.usarIvaEmpresa}
                                        />
                                        <small className="servico-form-help">
                                            {editFormData.impostos.usarIvaEmpresa
                                                ? `Usando IVA da empresa (${configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})`
                                                : editFormData.impostos.iva !== null ? `IVA específico: ${editFormData.impostos.iva}%` : 'IVA específico do serviço'}
                                        </small>
                                    </div>
                                    <div className="servico-form-group">
                                        <label>ISPC (%)</label>
                                        <input type="number" name="impostos.ispc" value={editFormData.impostos.ispc || 0} onChange={handleEditChange} placeholder="0" step="0.01" min="0" max="100" />
                                    </div>
                                </div>
                                <div className="servico-form-group">
                                    <label className="servico-checkbox-label">
                                        <input
                                            type="checkbox"
                                            name="impostos.usarIvaEmpresa"
                                            checked={editFormData.impostos.usarIvaEmpresa}
                                            onChange={handleEditChange}
                                        />
                                        Usar IVA da empresa ({configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="servico-modal-actions">
                            <button type="submit" className="servico-modal-btn-primary" disabled={editLoading}>
                                {editLoading ? 'A atualizar...' : 'Salvar Alterações'}
                            </button>
                            <button type="button" className="servico-modal-btn-secondary" onClick={() => { setShowEditModal(false); resetEditForm(); }}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )}

            {/* MODAL DE DETALHES */}
{showDetailsModal && servicoDetalhes && (
    <div className="servico-modal-overlay" onClick={() => setShowDetailsModal(false)}>
        <div className="servico-modal-content servico-detalhes-modal" onClick={(e) => e.stopPropagation()}>
            <div className="servico-modal-header">
                <h3>
                    <Icon name="build" size={22} />
                    {servicoDetalhes.nome}
                    {!servicoDetalhes.ativo && (
                        <span className="servico-status-badge inactive" style={{ marginLeft: '0.5rem' }}>
                            <Icon name="block" size={12} /> Inativo
                        </span>
                    )}
                </h3>
                <button className="servico-modal-close" onClick={() => setShowDetailsModal(false)}>×</button>
            </div>
            <div className="servico-modal-body">
                <div className="servico-modal-tabs">
                    <button type="button" className={`servico-modal-tab-btn ${detailsActiveTab === 'dados' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('dados')}>
                        <Icon name="info" size={16} />
                        <span className="tab-label">Dados</span>
                    </button>
                    <button type="button" className={`servico-modal-tab-btn ${detailsActiveTab === 'graficos' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('graficos')}>
                        <Icon name="trending_up" size={16} />
                        <span className="tab-label">Gráficos</span>
                    </button>
                    <button type="button" className={`servico-modal-tab-btn ${detailsActiveTab === 'impostos' ? 'active' : ''}`} onClick={() => setDetailsActiveTab('impostos')}>
                        <Icon name="receipt" size={16} />
                        <span className="tab-label">Impostos</span>
                    </button>
                </div>

                <div className={`servico-modal-tab-panel ${detailsActiveTab === 'dados' ? 'active' : ''}`}>
                    <div className="servico-detalhes-grid">
                        <div className="servico-info-item">
                            <span className="servico-label">📌 Código</span>
                            <span className="servico-value">{servicoDetalhes.codigo || '-'}</span>
                        </div>
                        <div className="servico-info-item">
                            <span className="servico-label">📂 Categoria</span>
                            <span className="servico-value">{servicoDetalhes.categoriaId?.nome || '-'}</span>
                        </div>
                        <div className="servico-info-item">
                            <span className="servico-label">💰 Preço Venda</span>
                            <span className="servico-value">{formatarMoeda(servicoDetalhes.precoVenda)}</span>
                        </div>
                        <div className="servico-info-item">
                            <span className="servico-label">📊 Tipo de Preço</span>
                            <span className="servico-value">
                                <span className="servico-badge-tipo-preco">
                                    {getTipoPrecoLabel(servicoDetalhes.tipoPreco)}
                                </span>
                            </span>
                        </div>
                        <div className="servico-detalhes-info-item">
                            <span className="servico-label">⏱️ Duração Estimada</span>
                            <span className="servico-value">
                                {servicoDetalhes.duracaoEstimada
                                    ? `${servicoDetalhes.duracaoEstimada} horas`
                                    : '-'}
                            </span>
                        </div>
                        <div className="servico-detalhes-info-item">
                            <span className="servico-label">📌 Status</span>
                            <span className="servico-value">
                                <span className={`servico-status-badge ${servicoDetalhes.ativo ? 'active' : 'inactive'}`}>
                                    <Icon name={servicoDetalhes.ativo ? 'check_circle' : 'block'} size={12} />
                                    {servicoDetalhes.ativo ? 'Ativo' : 'Inativo'}
                                </span>
                            </span>
                        </div>
                        <div className="servico-detalhes-info-item">
                            <span className="servico-label">📅 Data de Criação</span>
                            <span className="servico-value">{formatarDataHora(servicoDetalhes.createdAt)}</span>
                        </div>
                        <div className="servico-detalhes-info-item">
                            <span className="servico-label">🔄 Última Atualização</span>
                            <span className="servico-value">{formatarDataHora(servicoDetalhes.updatedAt)}</span>
                        </div>
                    </div>
                    {servicoDetalhes.descricao && (
                        <div className="servico-detalhes-descricao-box">
                            <h4>📝 Descrição</h4>
                            <p>{servicoDetalhes.descricao}</p>
                        </div>
                    )}
                </div>

                <div className={`servico-modal-tab-panel ${detailsActiveTab === 'graficos' ? 'active' : ''}`}>
                    <div className="servico-graficos-grid">
                        <div className="servico-grafico-card">
                            <SimpleBarChart
                                title="💰 Preço do Serviço"
                                labels={['Preço de Venda']}
                                data={[servicoDetalhes.precoVenda || 0]}
                                colors={['#4f46e5']}
                                formatValue={formatarMoeda}
                            />
                        </div>
                        <div className="servico-grafico-card servico-metrics-card">
                            <h4 className="servico-chart-title">📈 Métricas do Serviço</h4>
                            <div className="servico-metrics-grid">
                                <div className="servico-metric-item">
                                    <span className="servico-metric-label">Tipo de Preço</span>
                                    <span className="servico-metric-value">
                                        <span className="servico-badge-tipo-preco">
                                            {getTipoPrecoLabel(servicoDetalhes.tipoPreco)}
                                        </span>
                                    </span>
                                </div>
                                <div className="servico-metric-item">
                                    <span className="servico-metric-label">Duração Estimada</span>
                                    <span className="servico-metric-value">
                                        {servicoDetalhes.duracaoEstimada
                                            ? `${servicoDetalhes.duracaoEstimada}h`
                                            : 'N/A'}
                                    </span>
                                </div>
                                <div className="servico-metric-item">
                                    <span className="servico-metric-label">Status</span>
                                    <span className="servico-metric-value">
                                        <span className={`servico-status-badge ${servicoDetalhes.ativo ? 'active' : 'inactive'}`}>
                                            {servicoDetalhes.ativo ? 'Ativo' : 'Inativo'}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`servico-modal-tab-panel ${detailsActiveTab === 'impostos' ? 'active' : ''}`}>
                    <div className="servico-detalhes-grid servico-impostos-grid">
                        <div className="servico-info-item">
                            <span className="servico-label">🧾 IVA</span>
                            <span className="servico-value">
                                {servicoDetalhes.impostos?.usarIvaEmpresa
                                    ? `${configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'} (Empresa)`
                                    : servicoDetalhes.impostos?.iva !== null ? `${servicoDetalhes.impostos.iva}%` : 'N/A'}
                            </span>
                        </div>
                        <div className="servico-detalhes-info-item">
                            <span className="servico-label">🧾 ISPC</span>
                            <span className="servico-value">{servicoDetalhes.impostos?.ispc || 0}%</span>
                        </div>
                        <div className="servico-detalhes-info-item full-width">
                            <span className="servico-label">📋 Detalhes do IVA</span>
                            <span className="servico-value">
                                {servicoDetalhes.impostos?.usarIvaEmpresa
                                    ? `Usando IVA configurado na empresa (${configEmpresa?.iva !== null && configEmpresa?.iva !== undefined ? `${configEmpresa.iva}%` : 'N/D'})`
                                    : servicoDetalhes.impostos?.iva !== null
                                        ? `IVA específico do serviço: ${servicoDetalhes.impostos.iva}%`
                                        : 'Nenhum IVA configurado'}
                            </span>
                        </div>
                        <div className="servico-detalhes-info-item full-width">
                            <span className="servico-label">📋 Detalhes do ISPC</span>
                            <span className="servico-value">
                                {servicoDetalhes.impostos?.ispc > 0
                                    ? `ISPC de ${servicoDetalhes.impostos.ispc}% aplicado`
                                    : 'Sem ISPC configurado'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="servico-detalhes-modal-actions">
                <button className="servico-modal-btn-primary" onClick={() => handleEdit(servicoDetalhes)}>
                    <Icon name="edit" size={16} /> Editar
                </button>
                <button className="servico-modal-btn-secondary" onClick={() => setShowDetailsModal(false)}>Fechar</button>
            </div>
        </div>
    </div>
)}

{/* MODAL DE CONFIRMAÇÃO DE EXCLUSÃO */}
{showDeleteModal && servicoToDelete && (
    <div className="servico-modal-overlay" onClick={closeDeleteModal}>
        <div className="servico-modal-content-popups servico-modal-confirm" onClick={(e) => e.stopPropagation()}>
            <div className="servico-modal-header">
                <h3><span className="servico-header-icon">⚠️</span> Confirmar Exclusão</h3>
                <button className="servico-modal-close" onClick={closeDeleteModal}>×</button>
            </div>
            <div className="popup-modal-body">
                <div className="servico-confirm-icon warning">
                    <Icon name="warning" size={32} />
                </div>
                <h4>Remover serviço?</h4>
                <p>Tem certeza que deseja remover o serviço <strong>{servicoToDelete.nome}</strong>?</p>
                <p className="servico-confirm-subtext"><Icon name="info" size={14} /> Esta ação é irreversível.</p>
            </div>
            <div className="popup-modal-actions">
                <button className="servico-btn-confirm-danger" onClick={confirmDelete}>
                    <Icon name="delete_forever" size={16} /> Eliminar
                </button>
                <button className="servico-btn-cancel" onClick={closeDeleteModal}>Cancelar</button>
            </div>
        </div>
    </div>
)}

            {/* HEADER */}
            <div className="servicos-header">
                <div className="header-title">
                    <h2><Icon name="build" size={24} /> Gestão de Serviços</h2>
                    <p>Gerencie os serviços prestados pela sua empresa</p>
                </div>
                <div className="header-actions">
                    <button className="btn-export" onClick={() => exportarServicos('excel')} title="Exportar Excel">
                        <Icon name="file_download" size={18} /> Excel
                    </button>
                    <button className="btn-export" onClick={() => exportarServicos('csv')} title="Exportar CSV">
                        <Icon name="file_download" size={18} /> CSV
                    </button>
                    <button className="btn-create" onClick={() => setShowCreateModal(true)}>
                        <Icon name="add" size={18} /> Novo Serviço
                    </button>
                </div>
            </div>

            {/* MENSAGENS */}
            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    <Icon name={message.type === 'success' ? 'check_circle' : 'error'} size={16} />
                    <span>{message.text}</span>
                    <button className="alert-close" onClick={() => setMessage({ text: '', type: '' })}>×</button>
                </div>
            )}

            {/* KPIs */}
            <div className="servicos-kpi-grid">
                <div className="kpi-card primary">
                    <div className="kpi-icon"><Icon name="build" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarNumero(stats.total)}</span>
                        <span className="kpi-label">Total Serviços</span>
                    </div>
                </div>
                <div className="kpi-card success">
                    <div className="kpi-icon"><Icon name="check_circle" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarNumero(stats.ativos)}</span>
                        <span className="kpi-label">Ativos</span>
                    </div>
                    <span className="kpi-change positive">{stats.total > 0 ? Math.round((stats.ativos / stats.total) * 100) : 0}%</span>
                </div>
                <div className="kpi-card warning">
                    <div className="kpi-icon"><Icon name="block" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarNumero(stats.inativos)}</span>
                        <span className="kpi-label">Inativos</span>
                    </div>
                </div>
                <div className="kpi-card info">
                    <div className="kpi-icon"><Icon name="attach_money" /></div>
                    <div className="kpi-info">
                        <span className="kpi-value">{formatarMoeda(stats.precoMedio)}</span>
                        <span className="kpi-label">Preço Médio</span>
                    </div>
                </div>
            </div>

            {/* FILTROS */}
            <div className="servicos-filters">
                <div className="search-box">
                    <Icon name="search" size={18} />
                    <input type="text" placeholder="Pesquisar por nome, código, descrição ou categoria..." value={searchTerm || ''} onChange={(e) => setSearchTerm(e.target.value)} />
                    {searchTerm && (
                        <button className="search-clear" onClick={() => setSearchTerm('')}>
                            <Icon name="close" size={16} />
                        </button>
                    )}
                </div>
                <div className="filter-actions">
                    <button className="btn-filter" onClick={() => setShowFiltros(!showFiltros)}>
                        <Icon name="filter_list" size={18} />
                        {showFiltros ? 'Ocultar Filtros' : 'Filtros'}
                    </button>
                    <button className="btn-refresh" onClick={fetchServicos} title="Atualizar">
                        <Icon name="refresh" size={18} />
                    </button>
                </div>
            </div>

            {/* FILTROS AVANÇADOS */}
            {showFiltros && (
                <div className="servicos-filtros-avancados">
                    <div className="filtros-row">
                        <div className="filtro-group">
                            <label>Categoria</label>
                            <select value={filtros.categoria} onChange={(e) => setFiltros({ ...filtros, categoria: e.target.value })}>
                                <option value="todos">Todas as Categorias</option>
                                {categorias.map(cat => (
                                    <option key={cat._id} value={cat._id}>{cat.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="filtro-group">
                            <label>Tipo de Preço</label>
                            <select value={filtros.tipoPreco} onChange={(e) => setFiltros({ ...filtros, tipoPreco: e.target.value })}>
                                <option value="todos">Todos</option>
                                {TIPOS_PRECO.map(t => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="filtro-group">
                            <label>Status</label>
                            <select value={filtros.ativo} onChange={(e) => setFiltros({ ...filtros, ativo: e.target.value })}>
                                <option value="todos">Todos</option>
                                <option value="ativo">✅ Ativos</option>
                                <option value="inativo">❌ Inativos</option>
                            </select>
                        </div>
                        <button className="btn-aplicar-filtros" onClick={() => filtrarServicos()}>
                            <Icon name="filter_list" size={16} /> Aplicar
                        </button>
                        <button className="btn-limpar-filtros" onClick={limparFiltros}>
                            <Icon name="clear" size={16} /> Limpar
                        </button>
                    </div>
                </div>
            )}

            {/* TABELA */}
            {loading ? (
                <div className="loading-container">
                    <div className="spinner-large"></div>
                    <p>A carregar serviços...</p>
                </div>
            ) : (
                <div className="servicos-table-container">
                    <table className="servicos-table">
                        <thead>
                            <tr>
                                <th className="col-data">Data/Hora</th>
                                <th className="col-codigo">Código</th>
                                <th className="col-nome">Nome</th>
                                <th className="col-categoria">Categoria</th>
                                <th className="col-preco">Preço</th>
                                <th className="col-tipo">Tipo Preço</th>
                                <th className="col-duracao">Duração</th>
                                <th className="col-status">Status</th>
                                <th className="col-acoes">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentServicos.length === 0 ? (
                                <tr className="empty-row">
                                    <td colSpan="9">
                                        <div className="empty-state">
                                            <Icon name="build" size={48} />
                                            <p>Nenhum serviço encontrado</p>
                                            <button className="btn-create-small" onClick={() => setShowCreateModal(true)}>
                                                Criar primeiro serviço
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                currentServicos.map(servico => {
                                    const status = getStatusBadge(servico.ativo !== false);
                                    const isAtivo = servico.ativo !== false;

                                    return (
                                        <tr key={servico._id} className={!isAtivo ? 'inactive-row' : ''}>
                                            <td className="col-data">
                                                <span className="data-hora-badge">
                                                    <span className="data">{formatarDataHora(servico.createdAt).split(' ')[0]}</span>
                                                    <span className="hora">{formatarDataHora(servico.createdAt).split(' ')[1]}</span>
                                                </span>
                                            </td>
                                            <td><span className="codigo-badge">{servico.codigo || '-'}</span></td>
                                            <td>
                                                <div className="servico-info">
                                                    <strong>{servico.nome}</strong>
                                                    {!isAtivo && (
                                                        <span className="status-badge inactive" style={{ fontSize: '0.5rem', padding: '0.1rem 0.4rem' }}>
                                                            Inativo
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>{servico.categoriaId?.nome || '-'}</td>
                                            <td>{formatarMoeda(servico.precoVenda)}</td>
                                            <td>
                                                <span className="tipo-preco-badge">
                                                    {getTipoPrecoLabel(servico.tipoPreco)}
                                                </span>
                                            </td>
                                            <td>
                                                {servico.duracaoEstimada
                                                    ? `${servico.duracaoEstimada}h`
                                                    : '-'}
                                            </td>
                                            <td>
                                                <span className={`status-badge ${status.class}`}>
                                                    <Icon name={status.icon} size={12} />
                                                    {status.label}
                                                </span>
                                            </td>
                                            <td className="actions-cell">
                                                <button className="action-btn view" onClick={() => verDetalhes(servico)} title="Ver detalhes">
                                                    <Icon name="visibility" size={16} />
                                                </button>
                                                <button className="action-btn edit" onClick={() => handleEdit(servico)} title="Editar">
                                                    <Icon name="edit" size={16} />
                                                </button>
                                                <button className="action-btn delete" onClick={() => openDeleteModal(servico)} title="Excluir">
                                                    <Icon name="delete" size={16} />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                    {renderPagination()}
                </div>
            )}
        </div>
    );
}